module.exports = __webpack_public_path__ + "r-v3/img/ico_determination_black.fc11fd9a.svg";